import * as rawInvariant from 'invariant';

export const invariant = rawInvariant;
